export default __webpack_public_path__ + "static/media/total-users-icon.9c49a9d1.svg";